// @flow

import * as React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'

import {Spinner} from '../../loadable'
import Header from '../../components/intake/header'
import {getProductCategories} from '../../reducers/products'
import {
  fetchBaby,
  fetchOffers,
  fetchBabyList,
  fetchOptionals,
} from '../../actions/baby'
import {fetchTasks} from '../../actions/tasks'
import {fetchProducts} from '../../actions/products'
import type {
  Baby,
  BabyList,
  ProductCategory,
  State as ReduxState,
  Dispatch,
} from '../../types'

type Props = {
  children?: React.Node,
  dispatch: Dispatch,
  baby: ?Baby,
  match: any,
  babyList: ?BabyList,
  +categories: $ReadOnlyArray<ProductCategory>,
}

type State = {
  isDataLoaded: boolean,
}

export class IntakeViewWrapper extends React.Component<Props, State> {
  state = {
    isDataLoaded: false,
  }

  componentDidMount() {
    const {
      match: {
        params: {babyToken},
      },
      dispatch,
    } = this.props
    Promise.all([
      dispatch(fetchBaby(babyToken)),
      dispatch(fetchBabyList(babyToken)),
      dispatch(fetchOptionals(babyToken)),
      dispatch(fetchTasks(babyToken)),
      dispatch(fetchProducts(babyToken)),
      dispatch(fetchOffers(babyToken)),
    ]).then(() => {
      this.setState({
        isDataLoaded: true,
      })
    })
  }

  render() {
    const {children, categories} = this.props
    if (!this.state.isDataLoaded) {
      return <Spinner />
    }
    return (
      <div className="app-view intake-view container">
        <Header categories={categories} />
        {children}
        <br />
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  categories: getProductCategories(state),
  baby: state.baby.baby,
  babyList: state.baby.list,
})

export default withRouter(connect(mapStateToProps)(IntakeViewWrapper))
